export const primaryColor = '#E50046';

export const secondaryColor = '#1D1D1B';

export const footerColor = secondaryColor;

export const whiteColor = '#FFF';
export const blackColor = '#000';